type TemplateBrowserAllowedFeatureType = Partial<{
	'template-browser': {
		'space-picker-disabled': boolean;
	};
	'template-browser-panel': {
		'space-picker-disabled': boolean;
	};
}>;

export type EnableRedirectionAllowedFeatureType = Partial<{
	'enable-redirection': {
		'cross-site-tenant-id': string;
	};
}>;

export type ObjectAllowedFeaturesType =
	| string
	| TemplateBrowserAllowedFeatureType
	| EnableRedirectionAllowedFeatureType;

const IN_EDITOR_TEMPLATES_PANEL_ALLOWED_FEATURES = [
	'template-browser',
	'template-browser-panel',
];

const hasAllowedFeature = (feature: unknown, featureName: string): boolean => {
	if (typeof feature === 'string') {
		return feature === featureName;
	}

	if (feature && typeof feature === 'object') {
		return Object.prototype.hasOwnProperty.call(feature, featureName);
	}

	return false;
};

export const isInEditorTemplatesPanelEnabled = (
	allowedFeatures?: 'all' | unknown[],
): boolean => {
	if (allowedFeatures === 'all') {
		return true;
	}

	return (
		allowedFeatures?.some((feature) =>
			IN_EDITOR_TEMPLATES_PANEL_ALLOWED_FEATURES.some((featureName) =>
				hasAllowedFeature(feature, featureName),
			),
		) ?? false
	);
};

export const isRedirectionEnabled = (feature: ObjectAllowedFeaturesType): boolean => {
	if (typeof feature === 'object') {
		return 'enable-redirection' in feature;
	}

	if (typeof feature === 'string') {
		try {
			const parsedFeature = JSON.parse(feature);
			return (
				parsedFeature && typeof parsedFeature === 'object' && 'enable-redirection' in parsedFeature
			);
		} catch {
			return false;
		}
	}
	return false;
};

export const getCrossSiteTenantIdFromAllowedFeature = (
	feature?: string | EnableRedirectionAllowedFeatureType,
): string | undefined => {
	if (!feature) {
		return undefined;
	}

	if (typeof feature === 'string') {
		try {
			const parsed = JSON.parse(feature);
			return parsed['enable-redirection']?.['cross-site-tenant-id'];
		} catch {
			return undefined;
		}
	}
	return feature['enable-redirection']?.['cross-site-tenant-id'];
};
